// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/common/Button.css */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  text-decoration: none;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Button sizes */
.btn-small {
  padding: 8px 16px;
  font-size: 0.875rem;
}

.btn-medium {
  padding: 10px 20px;
  font-size: 1rem;
}

.btn-large {
  padding: 12px 24px;
  font-size: 1.125rem;
}

/* Button variants */
.btn-primary {
  background-color: #667eea;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #5a67d8;
  transform: translateY(-1px);
}

.btn-outline {
  background-color: transparent;
  color: #667eea;
  border: 2px solid #667eea;
}

.btn-outline:hover:not(:disabled) {
  background-color: #667eea;
  color: white;
}

.btn-secondary {
  background-color: #718096;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #4a5568;
}

.btn-danger {
  background-color: #e53e3e;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background-color: #c53030;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Button.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* src/components/common/Button.css */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Button sizes */\n.btn-small {\n  padding: 8px 16px;\n  font-size: 0.875rem;\n}\n\n.btn-medium {\n  padding: 10px 20px;\n  font-size: 1rem;\n}\n\n.btn-large {\n  padding: 12px 24px;\n  font-size: 1.125rem;\n}\n\n/* Button variants */\n.btn-primary {\n  background-color: #667eea;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #5a67d8;\n  transform: translateY(-1px);\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: #667eea;\n  border: 2px solid #667eea;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background-color: #667eea;\n  color: white;\n}\n\n.btn-secondary {\n  background-color: #718096;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #4a5568;\n}\n\n.btn-danger {\n  background-color: #e53e3e;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #c53030;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
